import React from "react";
import DateRangeSelect from "../common/DateRangeSelect.jsx";
import SelectInput from "../common/SelectInput.jsx";
import { leadSource } from "../../assets/consts/index.js";

import AdfScannerIcon from "@mui/icons-material/AdfScanner";
import PersonIcon from "@mui/icons-material/Person";
import PopperButton from "./PopperButton.jsx";
import { Restore } from "@material-ui/icons";
import SearchInput from "./SearchInput.jsx";

export default function FilterComponent({
  params,
  onParamChange,
  onDateChange,
  options,
  handleResetClick,
  dataStateMdo,
}) {
  const leadContact = React.useRef("");

  const handleChangeLeadContact = (e) => {
    leadContact.current = e.target.value;
    //console.log(leadContact);
  };

  const handleChangeLeadContactButtonClick = () => {
    onParamChange("contact_number")({ target: { value: leadContact.current } });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onParamChange("contact_number")(e);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 16,
      }}
    >
      <div>
        {options.leadSource && (
          <SelectInput
            id="filter-by-lead-source"
            label="Lead Source"
            onChange={onParamChange("lead_source")}
            options={leadSource.map((e) => ({ value: e, label: e }))}
            value={params.lead_source}
            style={{ width: 260, margin: "8px 8px 0 0" }}
            startAdornment={
              <AdfScannerIcon style={{ color: "rgba(54, 43, 115, 0.4)" }} />
            }
          />
        )}
        {options.leadContact && (
          <SearchInput
            id="search_box"
            autoFocus={true}
            label={`Lead Contact Number`}
            onChange={handleChangeLeadContact}
            style={{ width: 260, margin: "8px 8px 0 0" }}
            onKeyDown={handleKeyDown}
            onEndIconClick={handleChangeLeadContactButtonClick}
          />
        )}
        {options.mao && (
          <SelectInput
            id="filter-by-MAO"
            label="MAO"
            onChange={onParamChange("mao_number")}
            options={
              dataStateMdo?.data?.data
                ? dataStateMdo.data.data.map((e) => ({
                    label: e.name,
                    value: e.contact_number,
                  }))
                : []
            }
            value={params.mao_number}
            style={{ width: 260, margin: "8px 8px 0 0" }}
            startAdornment={
              <PersonIcon style={{ color: "rgba(54, 43, 115, 0.4)" }} />
            }
          />
        )}
        {options.date && (
          <DateRangeSelect
            endDate={params.end_time}
            startDate={params.start_time}
            onChange={onDateChange}
          />
        )}
      </div>
      <div>
        {options.reset && (
          <PopperButton
            width={180}
            onClick={() => {
              leadContact.current = "";
              handleResetClick();
            }}
            gutter={[1, 0, 0]}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Restore style={{ color: "#E2136E" }} />
              <div style={{ marginLeft: 16, textAlign: "left" }}>
                <p
                  style={{
                    color: "#E2136E",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "16px",
                    margin: 0,
                  }}
                >
                  Reset Filters
                </p>
              </div>
            </div>
          </PopperButton>
        )}
      </div>
    </div>
  );
}
